import script from "./area-picker-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./area-picker-panel.vue?vue&type=script&lang=ts&setup=true"

import "./area-picker-panel.vue?vue&type=style&index=0&id=2779fdc4&lang=css"

const __exports__ = script;

export default __exports__